/* eslint-disable max-len */
import { motion } from 'framer-motion';
import styled from 'styled-components';

export const StyledUserAttributesModal = styled(motion.div)`
    display: flex;
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    align-items: center;
    padding: 10px;
    gap: 10px;
    position: relative;
    background: ${(p) => p.theme.colors.white};
    /* background-image: radial-gradient(${(p) => p.theme.colors.mutedTransparent} 2px, transparent 0);
    background-size: 27px 27px;
    background-position: -19px -19px; */
`;

export const StyledUserAttributeImageWrapper = styled(motion.div)`
    flex: 1;
    height: 100%;
    box-sizing: border-box;
    background: linear-gradient(180deg, ${(p) => p.theme.colors.loopEmerald} 0%, #013329 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    align-items: center;
    border-radius: 24px;
    margin: 0;
    overflow: hidden;
`;

export const StyledUserAttributesImage = styled(motion.img)`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const StyledUserAttributesBody = styled(motion.div)`
    flex: 1;
    padding: 40px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const StyledUserAttributesContent = styled(motion.div)`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const StyledUserAttributesItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const StyledUserAttributesConditionsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const StyledUserAttributesConditions = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    flex-wrap: wrap;
`;

export const StyledUserAttributesConditionItem = styled(motion.div)<{ $isSelected: boolean }>`
    border-radius: 100px;
    padding: 10px 16px;
    background-color: ${(p) => (p.$isSelected ? p.theme.colors.mutedTransparent : p.theme.colors.white)};
    border: 1px solid ${(p) => p.theme.colors.surfaceFillEmerald};
    display: flex;
    align-items: center;
    gap: 4px;
    box-sizing: border-box;
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s;
`;

export const StyledAttributeConditionIcon = styled(motion.img)`
    width: 20px;
    height: 20px;
`;

export const StyledUserAttributeFieldsContainer = styled.div`
    display: flex;
    gap: 24px;
    flex-wrap: wrap;
    align-items: center;

    & > div {
        flex-basis: calc(50% - 12px);
        flex-grow: 1;
    }
`;

export const StyledUserAttributesSuccessScreen = styled(StyledUserAttributesContent)`
    text-align: center;
    align-items: center;
`;

export const StyledUserAttributesSuccessIconWrapper = styled.div`
    width: 140px;
    height: 140px;
    position: relative;
`;

export const StyledUserAttributesSuccessIcon = styled.div`
    position: absolute;
    top: 52%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const StyledUserAttributeHrModal = styled.div`
    width: 500px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    background: linear-gradient(1.67deg, rgba(255, 255, 255, 0.1) 31.19%, #d3faf1 113.37%);
    align-items: center;
    padding-top: 18px;
    text-align: center;
`;

export const StyledUserAttributeHrBannerImg = styled.img`
    height: 142px;
    position: relative;
    left: -20px;
`;

export const StyledUserAttributesHrButton = styled.div`
    border-top: 0.5px solid ${(p) => p.theme.colors.seafoamGray};
    padding: 16px 32px;
    width: 100%;
    box-sizing: border-box;
`;

export const StyledUserAttributesHrText = styled(StyledUserAttributesItem)`
    padding: 0 24px;
`;
